<template>
    <Layout>

        <div slot="body" class="main-panel">
            <div class="content-wrapper">
                <div class="row">
                    <div class="col-3">
                        <div class="card">
                            <div class="card-body">
                                <div class="relative" v-if="!selected_tab">
                                    <h4 class="card-title">Intents</h4>
                                    <p class="card-description"> Intents</p>
                                    <button @click="createIntent" class="btn btn-sm btn-success cta">Create Intent</button>
                                </div>

                                <div class="relative" v-if="selected_tab">
                                    <h4 class="card-title">Groups</h4>
                                    <p class="card-description"> Groups</p>

                                    <button @click="createGroup" class="btn btn-sm btn-success cta">Create Group</button>
                                </div>

                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item" @click="changeSelect(false)">
                                        <a class="nav-link show active" id="intent-tab" data-toggle="tab" href="#intent"
                                           role="tab" aria-controls="home" aria-selected="true"><i
                                                class="mdi mdi-speaker mdi-16px"></i> Intents</a>
                                    </li>
                                    <li class="nav-item" @click="changeSelect(true)">
                                        <a class="nav-link show" id="profile-tab" data-toggle="tab" href="#groups"
                                           role="tab" aria-controls="profile" aria-selected="false"><i
                                                class="mdi mdi-group mdi-16px"></i> Groups</a>

                                    </li>

                                </ul>
                                <div class="tab-content">
                                    <div class="tab-pane fade  " v-bind:class="{show:!selected_tab,active:!selected_tab}" id="intent" role="tabpanel"
                                         aria-labelledby="intent-tab">

                                        <intent :key="intent_key" @onIntentSelect="selectIntent"></intent>
                                    </div>
                                    <div class="tab-pane fade" id="groups" role="tabpanel" v-bind:class="{show:selected_tab,active:selected_tab}"
                                         aria-labelledby="profile-tab">

                                        <div class="holder text-center p-t-10">
                                            <div v-if="groupedList.length<=0" class="m-t-20">
                                                <p>No Groups yet, create group to manage
                                                    related intents </p>
                                                <!--&lt;!&ndash;<button @click="createGroup" type="button"&ndash;&gt;-->
                                                <!--&lt;!&ndash;class="btn btn-sm btn-gradient-primary btn-icon-text">&ndash;&gt;-->
                                                <!--&lt;!&ndash;<i class="mdi mdi-file-plus btn-icon-prepend"></i> Create New Group&ndash;&gt;-->
                                                <!--&lt;!&ndash;</button>&ndash;&gt; -->
                                            </div>
                                            <div class="groups">
                                                <div class="group" :key="group.group_id" v-for="group in groupedList">

                                                    <input v-model="selected_group" id="checkers" type="checkbox"
                                                           :value="group.group_id"
                                                           class="form-check-input">
                                                    <router-link target="_blank"
                                                                 :to="{name:'group', params: {groupID:group.group_id,name:group.name?group.name:group.group_name}}">
                                                        <div class="gn">{{group.name?group.name:group.group_name}}</div>
                                                    </router-link>
                                                    <div @click="deleteGroup(group.group_id,group.group_name) " class="ic"><i
                                                            class="mdi mdi-delete mdi-16px"></i></div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-9" style="overflow-y: scroll;height: 100vh;">
                        <detail  @onUpdated="update" v-if="selected_intent" :intent="selected_intent" :key="selected_intent.key"
                                :name="selected_intent.name"></detail>
                    </div>
                </div>
            </div>
            <!-- content-wrapper ends -->

        </div>
    </Layout>
</template>

<script>
    import Layout from '../../components/Layout';
    import Loader from "../../components/Loader/Loader";
    import Detail from "../Detail/DetailPage";
    import Intent from "../../components/Intents/Intent.vue";
    import {userService} from '../../services/user.service';

    export default {

        name: "Dashboard",
        components: {Layout, Loader, Detail, Intent},
        data() {
            return {

                loading: true,
                loading_intent: false,
                dashboardData: "",
                intents: [],
                groups: [],
                filtered: [],
                selected: [],
                selected_group: [],
                groupList: [],
                selected_tab: false,
                selected_intent: "",
                query: "",
                showChecks: false,
                intent_key: (Math.random() + 1) * 20,
                detail_key: (Math.random() + 1) * 10 + 4,
                createNew: false,

            }
        },
        computed: {

            groupedList() {
                // let grouped = this.intents.filter(intent => {
                //     return intent.group_id != null;
                // })
                return this.groupList;
            },

        },
        methods: {
            changeSelect(bol) {
                this.selected_tab = bol;
            },
            selectIntent(intent) {
                this.selected_intent = intent;
            },
            selectGroup(group) {

            },
            async createIntent() {
                let inte = prompt("Enter new intent name");

                if (!!inte) {
                    await userService.createGroupIntent(inte, this.groupID)
                        .then((res) => {

                            this.loading = false;
                            // this.dashboardData = res;
                            this.intent_key = (Math.random() + 1) * 14;
                            this.$toastr.success("Success", "Created intent!", {timeOut: 5000});

                        }).catch((error) => {

                            this.$toastr.error(error.message, "Error creating intent!", {timeOut: 5000});

                        });
                }


            },
            async deleteGroup(id, name) {
                let yesDelete = window.confirm(
                    `Are you sure you want to delete ${name}?`
                );
                if (yesDelete) {
                    this.loading = true;


                    await userService.deleteGroup(id)
                        .then((res) => {
                            this.loading = false;
                            this.$toastr.success("Deleted", "Successfully deleted group!", {timeOut: 5000});
                            // window.location.reload();
                            this.getGroups();

                        }).catch((error) => {
                            this.loading = false;
                            this.$toastr.error(error.message, "Error deleting group!", {timeOut: 5000});
                        });
                }
            },
            createGroup() {
                let _self = this;
                this.$swal.fire({
                    title: 'Group Name',
                    input: 'text',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Create',
                    showLoaderOnConfirm: true,
                    preConfirm: async (login) => {
                        // alert(login);
                        return await userService.createGroup(login)
                            .then((res) => {
                                _self.groupList.push(res);
                                return res;
                            }).catch((error) => {
                                this.$swal.showValidationMessage(
                                    `Request failed: ${error}`
                                )
                            });

                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                }).then((result) => {
                    if (result.dismiss) {
                        return;
                    }
                    if (result) {
                        this.$swal.fire(
                            'Great!',
                            'Added group successfully!',
                            'success'
                        )
                        console.log(_self.groupList);
                    }
                })
            },
            update() {
                this.intent_key = (Math.random() + 1) * 20
            }
            , async getGroups() {
                await userService.getGroups()
                    .then((res) => {
                        // this.dashboardData = res;
                        this.groupList = res;
                        //console.log(this.groups);
                    }).catch((error) => {

                        this.$toastr.error(error.message, "Error loading groups!", {timeOut: 5000});

                    });
            }


        },
        async created() {
            this.getGroups();
        },


        // async beforeRouteEnter (to, from, next) {
        //     await dashboardService.fetchStats()
        //         .then((res) => {
        //             next(vm => vm.dashboardData = res);
        //         }).catch((err) => window.console.log(err));
        // }
    }
</script>

<style scoped>
    .card .card-body {
        padding: 0.5rem 1.1rem;
    }

    .card-body > h4 {
        padding-top: 15px;
    }

    .nav-tabs .nav-item {
        width: 50%;
    }

    .content-wrapper {
        background: #f2edf3;
        padding: 2.75rem 0.25rem;
        width: 100%;
        height: 95vh;
        overflow: hidden;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
    }

    .search-area {
        margin-top: 20px;
    }

    .bulk-actions {
        margin-top: 10px;
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }

    .intents, .groups {
        width: 93%;
        margin: auto;
        margin-top: 20px;
        left: 0;
        right: 0;
        height: 58vh;
        box-sizing: border-box;
        overflow: auto;
        overflow-y: scroll;
    }

    .intent, .group {
        margin-top: 10px;
        margin-bottom: 10px;
        cursor: grab;
        padding: 10px 8px;
        display: flex;
        position: relative;

    }

    .intent:hover, .group:hover {
        color: #353cd6;
        background: unset;
        font-weight: bold;
    }

    .intent:hover #checkers, .group:hover #checkerss {
        display: block;
    }

    .intent .utr, .group .gn {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-transform: capitalize;

    }

    .intent.selected, .group.selected {
        font-weight: bold;
        color: #353cd6 !important;
    }

    .col-3 {
        height: 100%;

    }

    .intent .linker {
        color: #343434;
    }

    .intent .ic, .group .ic {
        float: right;
        position: absolute;
        right: 5px;
    }

    a:hover {
        color: #0056b3 !important;
        text-decoration: underline;
    }

    .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
        color: #ffffff;
        background-color: blue;
        border-color: #353cd6 #4d6ed6 #2540d6;
    }

    input[type=checkbox]:checked {
        display: block;
    }

    input[type=checkbox]:not(:checked) {
        display: none;
    }

    .tab-content {
        min-height: 520px;
    }

    .group {
        width: 91%;
        margin-left: auto;
        margin-right: auto;
    }

    .m-t-20 {
        margin-top: 20px;
    }

    .relative {
        position: relative;
    }
    .relative .cta{
        position: absolute;
        right: 8px;
        top: 10px;
    }
</style>
